import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV2 } from './api';

interface IStartStopResponse {
  durationMin?: number;
  fileName: string;
  message: string;
  remaining?: number;
  sequence?: number;
  status: string;
}

interface IRecordingStatusResponse {
  active: boolean;
  roomName: string;
  startedAt?: number;
}

interface IRecordingRequestBody {
  recordingId: string;
}

interface IRecordingAccessResponse {
  allowed: boolean;
  remaining?: number;
}

export const aiSupervisorApi = createApi({
  reducerPath: 'aiSupervisor',
  baseQuery: baseQueryV2,
  tagTypes: ['RecordingStatus', 'RecordingAccess'],
  endpoints: (build) => ({
    startRecording: build.mutation<IStartStopResponse, IRecordingRequestBody>({
      query: ({ recordingId }) => ({
        url: `ai/recordings/${recordingId}/start`,
        method: 'POST',
        body: { additionalData: 'psychologist_started' },
      }),
      invalidatesTags: ['RecordingStatus'],
    }),

    stopRecording: build.mutation<IStartStopResponse, IRecordingRequestBody>({
      query: ({ recordingId }) => ({
        url: `ai/recordings/${recordingId}/stop`,
        method: 'POST',
        body: { additionalData: 'psychologist_stopped' },
      }),
      invalidatesTags: ['RecordingStatus'],
    }),

    getRecordingStatus: build.query<IRecordingStatusResponse, { recordingId: string }>({
      query: ({ recordingId }) => ({
        url: `ai/recordings/${recordingId}/status`,
        method: 'GET',
      }),
      providesTags: ['RecordingStatus'],
    }),

    getRecordingAccess: build.query<IRecordingAccessResponse, void>({
      query: () => ({
        url: 'ai/recordings/access',
        method: 'GET',
      }),
      providesTags: ['RecordingAccess'],
    }),
  }),
});

export const {
  useStartRecordingMutation,
  useStopRecordingMutation,
  useGetRecordingStatusQuery,
  useGetRecordingAccessQuery,
} = aiSupervisorApi;
